import { render } from "./WarGame.vue?vue&type=template&id=4f013956"
import script from "./WarGame.vue?vue&type=script&lang=js"
export * from "./WarGame.vue?vue&type=script&lang=js"

import "./WarGame.vue?vue&type=style&index=0&id=4f013956&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__